export default __webpack_public_path__ + "static/media/medical_condition.e079351a.png";